import { render, staticRenderFns } from "./cModalNurse.vue?vue&type=template&id=1c8eb5c3&lang=es"
import script from "./cModalNurse.vue?vue&type=script&lang=js"
export * from "./cModalNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports